import type { ReactElement } from "react";

import Svg, { Circle, Ellipse, G, Rect } from "react-native-svg";

const PlaceholderIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 48 48" width={width}>
    <Rect fill="#E4E9FF" height="48" width="48" />
    <G fill="#007F79">
      <Ellipse cx="24" cy="13" rx="5" ry="7.5" />
      <Ellipse cx="24" cy="35" rx="5" ry="7.5" />
      <Ellipse cx="13" cy="24" rx="7.5" ry="5" />
      <Ellipse cx="35" cy="24" rx="7.5" ry="5" />
    </G>
    <Circle cx="24" cy="24" fill="#A8DC68" r="6" />
  </Svg>
);

export default PlaceholderIllustrationSVG;
